module.exports = __webpack_public_path__ + "static/media/rasansha.52424cce.jpg";